<template>
  <v-textarea
    v-if="inputType === 'textarea'"
    v-model="context.value.value[props.field.key]"
    color="primary"
    :prepend-inner-icon="props.field.properties.icon"
    :label="label"
    :placeholder="placeholder"
  >
  </v-textarea>
  <v-text-field
    v-else
    v-model="context.value.value[props.field.key]"
    color="primary"
    :prepend-inner-icon="props.field.properties.icon"
    :label="label"
    :placeholder="placeholder"
    :type="inputType"
  ></v-text-field>
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { SchemaFormKitProps } from './types'

const { t, te } = useI18n()

const props = defineProps<SchemaFormKitProps>()
const context = useFormKitContext()

const label = computed(() => {
  if (!props.field.properties?.label) return ''

  return te(props.field.properties.label)
    ? t(props.field.properties.label)
    : props.field.properties.label
})

const placeholder = computed(() => {
  if (!props.field.properties?.placeholder) return label.value

  return te(props.field.properties.placeholder)
    ? t(props.field.properties.placeholder)
    : props.field.properties.placeholder
})

const inputType = computed(() => {
  if (!props.field.properties?.inputType) return 'text'

  return props.field.properties.inputType
})
</script>
